import { RootState } from '../types';

export const vennSelector = (state: RootState) => state.venn;
